import { combineReducers } from 'redux';

import {
  FETCH_PAGINATED_ENTITY_SUCCESS,
  FETCH_ENTITY_SINGLE_REQUEST,
  FETCH_ENTITY_SINGLE_SUCCESS,
  FETCH_ENTITY_SINGLE_FAILURE,
  FETCH_ENTITY_REQUEST,
  FETCH_ENTITY_SUCCESS,
  FETCH_ENTITY_FAILURE,
  FETCH_PAGINATED_ENTITY_REQUEST,
  FETCH_PAGINATED_ENTITY_FAILURE,
  FETCH_FILTERED_ENTITY_REQUEST,
  FETCH_FILTERED_ENTITY_SUCCESS,
  FETCH_FILTERED_ENTITY_FAILURE,
  UPDATE_ENTITY_SINGLE_REQUEST,
  UPDATE_ENTITY_SINGLE_SUCCESS,
  UPDATE_ENTITY_SINGLE_FAILURE,
  CREATE_ENTITY_SINGLE_REQUEST,
  CREATE_ENTITY_SINGLE_SUCCESS,
  CREATE_ENTITY_SINGLE_FAILURE,
  DELETE_ENTITY_SINGLE_REQUEST,
  DELETE_ENTITY_SINGLE_SUCCESS,
  DELETE_ENTITY_SINGLE_FAILURE,
  FETCH_PARTIAL_ENTITY_REQUEST,
  FETCH_PARTIAL_ENTITY_SUCCESS,
  FETCH_PARTIAL_ENTITY_FAILURE,
  FETCH_ENTITY_PER_DAY_REQUEST,
  FETCH_ENTITY_PER_DAY_SUCCESS,
  FETCH_ENTITY_PER_DAY_FAILURE,
} from '@store/entity/actions';

export const createReducerForEntity = (entityName) => {
  const initialFetchingState = {
    isItemListFetching: false, // all items
    isItemFetching: false, // single item
    isPaginatedListFetching: false, // paginated list
    isFilteredListFetching: false, // filtered
    isUpdateFetching: false,
    isCreateFetching: false,
    isDeleteFetching: false,
    isPartialEntityFetching: false,
    fetchingDates: [],
  };

  return (state = initialFetchingState, action) => {
    if (entityName !== action.entityName) {
      return state;
    }
    switch (action.type) {
      case FETCH_ENTITY_SINGLE_REQUEST: {
        return {
          ...state,
          isItemFetching: true,
        };
      }
      case FETCH_ENTITY_SINGLE_SUCCESS:
      case FETCH_ENTITY_SINGLE_FAILURE: {
        return {
          ...state,
          isItemFetching: false,
        };
      }

      case FETCH_ENTITY_REQUEST: {
        return {
          ...state,
          isItemListFetching: true,
        };
      }
      case FETCH_ENTITY_SUCCESS:
      case FETCH_ENTITY_FAILURE: {
        return {
          ...state,
          isItemListFetching: false,
        };
      }
      case FETCH_PAGINATED_ENTITY_REQUEST: {
        return {
          ...state,
          isPaginatedListFetching: true,
        };
      }
      case FETCH_PAGINATED_ENTITY_SUCCESS:
      case FETCH_PAGINATED_ENTITY_FAILURE: {
        return {
          ...state,
          isPaginatedListFetching: false,
        };
      }
      case FETCH_FILTERED_ENTITY_REQUEST: {
        return {
          ...state,
          isFilteredListFetching: true,
        };
      }
      case FETCH_FILTERED_ENTITY_SUCCESS:
      case FETCH_FILTERED_ENTITY_FAILURE: {
        return {
          ...state,
          isFilteredListFetching: false,
        };
      }
      case UPDATE_ENTITY_SINGLE_REQUEST: {
        return {
          ...state,
          isUpdateFetching: true,
        };
      }
      case UPDATE_ENTITY_SINGLE_SUCCESS:
      case UPDATE_ENTITY_SINGLE_FAILURE: {
        return {
          ...state,
          isUpdateFetching: false,
        };
      }
      case CREATE_ENTITY_SINGLE_REQUEST: {
        return {
          ...state,
          isCreateFetching: true,
        };
      }
      case CREATE_ENTITY_SINGLE_SUCCESS:
      case CREATE_ENTITY_SINGLE_FAILURE: {
        return {
          ...state,
          isCreateFetching: false,
        };
      }
      case DELETE_ENTITY_SINGLE_REQUEST: {
        return {
          ...state,
          isDeleteFetching: true,
        };
      }
      case DELETE_ENTITY_SINGLE_SUCCESS:
      case DELETE_ENTITY_SINGLE_FAILURE: {
        return {
          ...state,
          isDeleteFetching: false,
        };
      }
      case FETCH_PARTIAL_ENTITY_REQUEST: {
        return {
          ...state,
          isPartialEntityFetching: true,
        };
      }
      case FETCH_PARTIAL_ENTITY_SUCCESS:
      case FETCH_PARTIAL_ENTITY_FAILURE: {
        return {
          ...state,
          isPartialEntityFetching: false,
        };
      }
      case FETCH_ENTITY_PER_DAY_REQUEST: {
        return {
          ...state,
          fetchingDates: [...new Set(state.fetchingDates).add(action.arrivalDate)],
        };
      }
      case FETCH_ENTITY_PER_DAY_SUCCESS:
      case FETCH_ENTITY_PER_DAY_FAILURE: {
        return {
          ...state,
          fetchingDates: state.fetchingDates.filter((date) => date !== action.arrivalDate),
        };
      }
      default: {
        return state;
      }
    }
  };
};

export default combineReducers({
  properties: createReducerForEntity('properties'),
  categories: createReducerForEntity('categories'),
  users: createReducerForEntity('users'),
  products: createReducerForEntity('products'),
  facilities: createReducerForEntity('facilities'),
  spaTreatments: createReducerForEntity('spaTreatments'),
  spaDays: createReducerForEntity('spaDays'),
  pages: createReducerForEntity('pages'),
  spaClasses: createReducerForEntity('spaClasses'),
  spaPackages: createReducerForEntity('spaPackages'),
});
